import React from 'react';
import PropTypes from 'prop-types';
import clx from 'classnames';
import {
  Stepper,
  Step,
  StepLabel,
  makeStyles,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import ClockIcon from '@material-ui/icons/QueryBuilder';
import CheckIcon from '@material-ui/icons/Check';
import ErrorIcon from '@material-ui/icons/Clear';

const styles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 24,
    height: 24,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',

    '& svg': {
      color: 'white !important',
    },
  },
  unfocus: {
    opacity: 0.7,
  },
  fpshow: {
    '& svg': {
      cursor: 'pointer',
    },
  },
  completed: {
    backgroundColor: theme.palette.success.main,
  },
  pending: {
    backgroundColor: theme.palette.warning.main,
  },
  error: {
    backgroundColor: theme.palette.error.main,
  },
}));

const PendingIcon = () => {
  const classes = styles();

  return (
    <div className={clx(classes.root, classes.pending)}>
      <ClockIcon />
    </div>
  );
};

const CompletedIcon = () => {
  const classes = styles();

  return (
    <div className={clx(classes.root, classes.completed)}>
      <CheckIcon />
    </div>
  );
};

const FailedIcon = () => {
  const classes = styles();

  return (
    <div className={clx(classes.root, classes.error)}>
      <ErrorIcon />
    </div>
  );
};

const PayoutSteps = ({
  user,
  activeStep,
  setActiveStep,
  isHostInformationComplete,
}) => {
  const classes = styles();

  const icon = user.kyc_status === 'SUCCEDED' // eslint-disable-line
    ? CompletedIcon
    : user.kyc_status === 'PENDING' // eslint-disable-line
      ? PendingIcon
      : user.kyc_status === 'FAILED' // eslint-disable-line
        ? FailedIcon
        : null;

  return (
    <Stepper activeStep={activeStep} orientation="horizontal" alternativeLabel>
      <Step
        onClick={() => setActiveStep(0)}
        classes={{ completed: classes.unfocus }}
      >
        <StepLabel
          classes={{ root: classes.fpshow }}
          StepIconComponent={isHostInformationComplete ? CompletedIcon : null}
        >
          <FormattedMessage
            id="payout.steps.host"
            defaultMessage="Host information"
          />
        </StepLabel>
      </Step>
      <Step
        classes={{ root: classes.default, completed: classes.completed }}
        onClick={() => {
          if (!isHostInformationComplete) {
            return;
          }

          setActiveStep(1);
        }}
        disabled={!isHostInformationComplete}
      >
        <StepLabel
          classes={!user.kyc_status ? null : { root: classes.fpshow }}
          StepIconComponent={icon}
        >
          <FormattedMessage
            id="payout.steps.identity"
            defaultMessage="ID-documents"
          />
        </StepLabel>
      </Step>
    </Stepper>
  );
};

PayoutSteps.propTypes = {
  user: PropTypes.shape({
    kyc_status: PropTypes.oneOf(['SUCCEDED', 'FAILED', 'PENDING', 'UNVERIFIED']),
  }),
  activeStep: PropTypes.oneOf([0, 1]),
  setActiveStep: PropTypes.func.isRequired,
  isHostInformationComplete: PropTypes.bool,
};

export default PayoutSteps;
